import React from 'react';
import { Divider } from 'antd';
import { BankOutlined, CalendarOutlined, MacCommandOutlined, ShoppingOutlined } from '@ant-design/icons';
import { CardLayout } from '../../Layout';
import { CardBadge } from './CardBadge';
import dayjs from 'dayjs';
import { ITariff } from '../../../interfaces';
import { tF } from '../../../translate';
import { FieldInfoAdvanced, booleanYNText } from '../../Forms';
import CardStyles from '../../styles/m_itemCardStyles.less';
import TariffsStyles from '../m_styles.less';

interface ITariffCard extends ITariff {
    onClick: (e: any) => void;
    key?: string;
    onEdit?: () => void;
    toBuy?: boolean;
}

export const TariffCard: React.FC<ITariffCard> = ({
    name,
    description,
    companyName,
    createdAt,
    roamingPackagesCount,
    cardsCount,
    price = 0,
    outOfBundle,
    onClick,
    key = '1',
    companies,
    toBuy,
}: ITariffCard) => {
    return (
        <CardLayout icon={<MacCommandOutlined />} unboundTitle={name} clickable={true} onClick={onClick} key={key}>
            <div className={TariffsStyles.tariffCard}>
                {description ? (
                    <>
                        <div className={TariffsStyles.description}>{description}</div>
                        <Divider />
                    </>
                ) : null}
                <FieldInfoAdvanced icon={<BankOutlined className={CardStyles.labelIcon} />} title={'Created by'}>
                    {companyName}
                </FieldInfoAdvanced>
                <FieldInfoAdvanced icon={<CalendarOutlined className={CardStyles.labelIcon} />} title={'Created at'}>
                    {dayjs(createdAt).format('DD.MM.YYYY HH:mm')}
                </FieldInfoAdvanced>
                <FieldInfoAdvanced icon={<ShoppingOutlined className={CardStyles.labelIcon} />} title={'Packages'}>
                    <div className={TariffsStyles.badgesContainer}>
                        <CardBadge name={tF(`Local`)} />
                        <CardBadge name={`${tF('Roaming')} (${roamingPackagesCount})`} />
                    </div>
                </FieldInfoAdvanced>
                <FieldInfoAdvanced icon={<BankOutlined className={CardStyles.labelIcon} />} title={'Price'}>
                    {price} {'EUR'}
                </FieldInfoAdvanced>
                <FieldInfoAdvanced icon={<BankOutlined className={CardStyles.labelIcon} />} title={'Out Of Bundle'}>
                    {booleanYNText(outOfBundle)}
                </FieldInfoAdvanced>
                <Divider />
                {!toBuy ? (
                    <FieldInfoAdvanced title={'Assigned to companies'}>
                        <div className={TariffsStyles.badgesContainer}>
                            {companies?.slice(0, 3).map((value) => {
                                return (
                                    <div key={value.id} className={TariffsStyles.badge}>
                                        <CardBadge name={value.name} />
                                    </div>
                                );
                            })}
                            {companies && companies.length > 3 && (
                                <div key={'others'} className={TariffsStyles.badge}>
                                    <CardBadge name={`+${companies.length - 3}`} />
                                </div>
                            )}
                        </div>
                    </FieldInfoAdvanced>
                ) : null}
                <FieldInfoAdvanced title={'Cards using'}>
                    {' '}
                    <CardBadge name={`${cardsCount}`} />
                </FieldInfoAdvanced>
            </div>
        </CardLayout>
    );
};
